<template>
  <div id="app">

    <router-view/>

    <footer-final v-if="$route.name !== 'manage'"/>

    <!-- ui -->
    <modal-cookies/>
    <div id="ui">
      <Tbar/>
      <!-- <Tbar v-on:setCurrentView="setCurrentView($event)"/> -->
    </div>

    <!-- popup --> <!-- korvataanko portalilla? -->
    <popup-content></popup-content>
    <!-- portals -->
    <portal-target name="modals"></portal-target>

    <!-- <siteBlocker></siteBlocker> -->

  </div>
</template>

<script>
import Tbar from '@/components/Tbar'
import popupContent from '@/components/popupContent'
import modalCookies from '@/components/modalCookies'
import footerFinal from '@/components/footerFinal'
// import siteBlocker from '@/components/siteBlocker'

export default {
  name: 'app',

  components: {
    Tbar,
    popupContent,
    modalCookies,
    footerFinal
    // siteBlocker
  },

  data () {
    return {
      showBlocker: true
    }
  },

  created () {
    if (this.$cookie.get('isLogged')) {
      this.$store.dispatch('setLoggedState', true)
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

#app {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 50px;
  overflow-y: auto;
  height: 100%;
  // scroll-behavior: smooth;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
